import React, { Component } from 'react'
import {
  Button,
  TableRow,
  TableCell,
  Table,
  TableBody,
  MenuItem,
  withStyles
} from '@material-ui/core'
import { Form, Field } from '../../form'
import { createYearItems } from '../../utils/admin.utils'

const styles = (theme) => ({
  textField: {
    fontSize: '15px',
    marginTop: theme.spacing(4),
    width: '100%'
  },
  tableCell: {
    border: 'none',
    padding: '8px 10px'
  },
  checkbox: {
    fontSize: '13px',
    padding: '0px 4px',
    margin: '0px'
  },
  select: {
    fontSize: '15px',
    padding: '4px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray'
  }
})

class AdminInvoiceFilterRow extends Component {
  render() {
    return (
      <AdminInvoiceFilterRowComponent
        {...this.props}
        onFormSubmit={this.onFormSubmit}
      />
    )
  }
}

export default withStyles(styles)(AdminInvoiceFilterRow)

const AdminInvoiceFilterRowComponent = ({ classes, form }) => {
  const { control, setValue } = form

  return (
    <Form {...form}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="user_email"
                label="Sähköposti"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="company_name"
                label="Yrityksen nimi"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="invoice_id"
                label="Laskunro."
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="referencenumber"
                label="Laskuviite"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="firstname"
                label="Asiakas nimi"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell} style={{ width: '150px' }}>
              <Field
                name="instant_payment"
                label="Pikapalkka"
                inputType="checkbox"
                control={control}
                className={classes.checkbox}
              />
              <Field
                name="overdue"
                label="Erääntynyt"
                inputType="checkbox"
                control={control}
                className={classes.checkbox}
              />
              <Field
                name="country"
                label="Ulkomaa"
                inputType="checkbox"
                control={control}
                className={classes.checkbox}
              />
              <Field
                name="is_manual_pay"
                label="Maksettu (M)"
                inputType="checkbox"
                control={control}
                className={classes.checkbox}
              />
            </TableCell>
            <TableCell className={classes.tableCell}></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="startdate"
                label="Alkupvm"
                style={{ width: '100%' }}
                inputType="datepicker"
                control={control}
                className={classes.textField}
                onChange={() => setValue('yearSelect', '')}
                clearable
                onClear={() => setValue('startdate', null)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="enddate"
                label="Loppupvm"
                style={{ width: '100%' }}
                inputType="datepicker"
                control={control}
                className={classes.textField}
                onChange={() => setValue('yearSelect', '')}
                clearable
                onClear={() => setValue('enddate', null)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="paymentdate"
                label="Maksupäivä"
                style={{ width: '100%' }}
                inputType="datepicker"
                control={control}
                className={classes.textField}
                clearable
                onClear={() => setValue('paymentdate', null)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="status"
                label="Tila"
                inputType="select"
                control={control}
                className={classes.select}
              >
                <MenuItem value={1}>Lähetetty</MenuItem>
                <MenuItem value={21}>Admin Luonnos</MenuItem>
                <MenuItem value={17}>Admin Lähetetty</MenuItem>
                <MenuItem value={2}>Maksettu</MenuItem>
                <MenuItem value={24}>Maksettu (MP)</MenuItem>
                <MenuItem value={18}>Admin Maksettu</MenuItem>
                <MenuItem value={3}>Käsittelyssä</MenuItem>
                <MenuItem value={4}>Hylätty</MenuItem>
                <MenuItem value={20}>Admin Hylätty</MenuItem>
                <MenuItem value={5}>Rahoitettu</MenuItem>
                <MenuItem value={6}>Ei nostettu</MenuItem>
                <MenuItem value={7}>Osittain maksu</MenuItem>
                <MenuItem value={19}>Admin Osittain maksu</MenuItem>
                <MenuItem value={8}>Ei hyväksytty</MenuItem>
                <MenuItem value={9}>Perinnässä</MenuItem>
                <MenuItem value={23}>Admin Perinnässä</MenuItem>
                <MenuItem value={10}>Reklamoitu</MenuItem>
                <MenuItem value={11}>Keskeytetty</MenuItem>
                <MenuItem value={12}>P Hylätty</MenuItem>
                <MenuItem value={22}>Muokattu Luonnos</MenuItem>
                <MenuItem value={13}>Muokattu</MenuItem>
              </Field>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="yearSelect"
                inputType="select"
                control={control}
                label="Valitse vuosi"
                className={classes.select}
                onChange={(event) => {
                  if (event.target.value === '') {
                    setValue('startdate', null)
                    setValue('enddate', null)
                  }
                }}
              >
                <MenuItem value={''}>Kaikki</MenuItem>
                {createYearItems()}
              </Field>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="adminInvoicePageSize"
                inputType="select"
                control={control}
                label="Näytetään"
                className={classes.select}
                style={{ width: '100px' }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Field>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Button
                className="pull-right"
                type="submit"
                variant="contained"
                style={{ width: '80px', marginTop: '36px' }}
              >
                HAE
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Form>
  )
}
